import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { downloadBlob } from '../../services/CommonService';
import './style.css';
import { Card } from 'react-bootstrap';
import { ic_broken_image, ic_loading_image } from '../../constants/Images';
import { Skeleton } from '@mui/material';


const GalleryImage2 = ({ eventName, image }) => {

  const {
    id,
    Name,
    Sequence,
    IsActive,
    CreatedBy,
    CreatedByName,
    CreatedDate,
    ModifiedBy,
    ModifiedByName,
    ModifiedDate,
    docId,
    DocTypeId,
    DocTypeDataId,
    docName,
    docExtension,
    docUrl,
    docIsActive,
    docCreatedBy,
    docCreatedDate,
    docModifiedBy,
    docModifiedDate,
    TotalCount
  } = image;
  const [url, setUrl] = useState('');
  const [isLoading, setLoading] = useState(true);

  const getImageUrl = async () => {
    const imagesUrl = await downloadBlob(docUrl)
    setUrl(imagesUrl)
  }

  useEffect(() => {
    getImageUrl()
  }, [])

  // if (isLoading) {
  //   return (
  //     <img
  //       src={ic_loading_image}
  //       alt={docName}
  //       className="gridImage1"
  //       onError={({ currentTarget }) => {
  //         currentTarget.onerror = null; // prevents looping
  //         currentTarget.src = ic_broken_image;
  //       }}
  //     />
  //   )
  // }

  return (
    <>
      {docExtension?.startsWith('video') ?
        <video
          src={url}
          className="gridImage1"
          alt={docName}
          onLoadedData={() => {
            setLoading(false);
          }}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = ic_broken_image;
          }} /> :
        <Card.Img
          src={url}
          alt={docName}
          className="gridImage1"
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = ic_broken_image;
          }} />
      }
    </>
  )
}

export default GalleryImage2

GalleryImage2.propTypes = {
  eventName: PropTypes.string,
  image: PropTypes.string
}
